module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1103.c8b440da.png";